"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateWidgets = void 0;
var tslib_1 = require("tslib");
var private_catalog_service_1 = require("../../../catalog-services/private-catalog-service");
var PrivateWidgets = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(PrivateWidgets, _super);
    function PrivateWidgets() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrivateWidgets.prototype.create = function (widgetId, data, requestConfig) {
        // TODO: replace with POST
        return this.httpClient.put("/catalog/widgets/".concat(widgetId), data, (0, tslib_1.__assign)({}, requestConfig));
    };
    PrivateWidgets.prototype.remove = function (widgetId, requestConfig) {
        return this.httpClient.delete("/catalog/widgets/".concat(widgetId), requestConfig);
    };
    PrivateWidgets.prototype.updateSettings = function (widgetId, data, requestConfig) {
        return this.httpClient.put("/catalog/widgets/".concat(widgetId, "/settings"), data, requestConfig);
    };
    return PrivateWidgets;
}(private_catalog_service_1.PrivateCatalogService));
exports.PrivateWidgets = PrivateWidgets;
//# sourceMappingURL=widgets.js.map